var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3F3E3E",
  fillRule: "nonzero",
  d: "M17.339 9.028c.314.288.346.75.09 1.072l-.07.078-4.851 4.774a.89.89 0 0 1-1.17.055l-.074-.069-4.637-4.773a.787.787 0 0 1 .048-1.15.89.89 0 0 1 1.131-.024l.078.07 4.023 4.141 4.223-4.154a.89.89 0 0 1 1.128-.086l.082.066z"
})));
export default SvgIconChevron;